module.exports = __webpack_public_path__ + "img/da57a3f.jpg";